import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { auditsApi } from '../api/audits.api';
import { useUsers } from '../../users/hooks/useUsers';
import { formatOptionsForSelect } from '../../../services/helpers';
import { MODULES, ACTIONS } from '../interfaces/modules.interface';
import { useDataTable } from '../../../hooks/useDataTable';
import { useModules } from '../../roles/hooks/useModules';
export const useAudits = () => {
  const table = useDataTable(auditsApi);
  const {
    setEntities,
    setLoading,
    searchValue,
    filters,
    dataFilters,
    setDataFilters,
    pageData,
  } = table;
  const { names: users, getNames: getNamesUser } = useUsers();
  const {modulesNames}=useModules(true)
  const fetchAudit = useCallback(async () => {
    setLoading(true);
    try {
     const response = await auditsApi.search();
      setEntities(response);
      return response;
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
      return [];
    } finally {
      setLoading(false);
    }
  }, [filters, searchValue, pageData, dataFilters]);
  useEffect(() => {
    getNamesUser();
  }, []);
  useEffect(() => {
    setDataFilters([
      {
        filter: 'usuario',
        value_filter: '',
        data: formatOptionsForSelect(users, 'id', 'name', 'Elegir usuario'),
        width: 'col-span-4 max-[768px]:col-span-12',
      },
      {
        filter: 'module_id',
        value_filter: '',
        data:formatOptionsForSelect(modulesNames, 'id', 'name', 'Elegir módulo'),
        width: 'col-span-3 max-[768px]:col-span-12',
      },
      {
        filter: 'action_id',
        value_filter: '',
        data: ACTIONS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, [users,modulesNames]);


  return {
    ...table,
    fetchAudit,
    users
  };
};
